
<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
       <h4 class="card-title">{{ $t('event_manage.direct_assign_stall') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <b-form-group
                class="row"
                label-cols-sm="4"
                label-for="registration_year"
                >
                <template v-slot:label>
                  <span class="font-weight-bold"> {{$t('retailerManagement.year')}}</span>
                </template>
                <b-form-select
                plain
                v-model="search.year"
                :options="yearList"
                id="year"
                >
                <template v-slot:first>
                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                </template>
                </b-form-select>
            </b-form-group>
          </b-col>
           <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider name="Event Type" vid="event_type" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="event_type"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                            <span class="font-weight-bold">{{$t('awareness_config.event_type')}}</span><span class="text-danger">*</span>
                        </template>
                        <b-form-select
                        plain
                        v-model="search.event_type_id"
                        id="event_type_id"
                        :options="eventTypeList"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <ValidationProvider name="Event Name" vid="event_info_id" rules="required|min_value:1">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="event_info_id"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                            <span span class="font-weight-bold">{{$t('awareness_config.event_name')}}</span>
                        </template>
                        <b-form-select
                        plain
                        v-model="search.event_info_id"
                        id="event_info_id"
                        :options="eventList"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                        {{ errors[0] }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
              <b-form-group
                  class="row"
                  label-cols-sm="4"
                  label-for="appliation_id"
              >
                <template v-slot:label>
                  <span class="font-weight-bold">{{ $t('retailerManagement.registration_id')}} </span>
                </template>
                <b-form-input
                    id="name"
                    v-model="search.registration_id"
                    @change="loadData"
                ></b-form-input>
              </b-form-group>
            </b-col>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('event_manage.direct_assign_stall')}}  {{ $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <router-link to="direct-assign-stall-form" :class="'btn btn-success text-light'">{{  $t('globalTrans.add_new') }}</router-link>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="data" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(registration_id)="data">
                      {{ $n(data.item.registration_id, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(year)="data">
                      {{ $n(data.item.year, { useGrouping: false   }) }}
                    </template>
                    <template v-slot:cell(registration_date)="data">
                      {{data.item.registration_date|dateFormat}}
                    </template>
                   <template v-slot:cell(action)="data">
                     <!-- <router-link title="Edit" :to="`/awareness-event-service/event-management-system/direct-assign-stall-form?id=${data.item.id}`" class="btn btn-sm btn-warning"><i class="ri-ball-pen-fill m-0"></i></router-link> -->
                      <b-button class="mr-2" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success border-info" size="sm" @click="view(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                   </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal-4" size="lg" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <p>
        <FormV :id="editItemId" :key="editItemId" :item="item"/>
      </p>
    </b-modal>
    <b-modal id="modal-detail" size="lg" :title="$t('globalTrans.details')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <DetailModal :id="viewitemId"  :item="item"/>
    </b-modal>
  </b-container>
</template>
<script>

import { mapGetters } from 'vuex'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { direactAssignList } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import FormV from './Form'
import DetailModal from './Details'
import flatpickr from 'flatpickr'
import { helpers } from '@/mixins/helper-functions'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    FormV, DetailModal
  },
  data () {
    return {
      search: {
        year: new Date().getFullYear(),
        registration_id: null,
        event_type_id: 0,
        apply_for: 1,
        event_info_id: 0

      },
      rows: [],
      editItemId: 0,
      item: [],
      data: [],
      isRetailer: false,
      ItemShow: false,
      viewitemId: 0,
      eventList: [],
      paymentTypeList: [
        { value: 2, text_en: 'Check Payment', text_bn: 'পেমেন্ট চেক' },
        { value: 3, text_en: 'Cash Payment', text_bn: 'নগদে টাকা প্রদান' }
      ]
    }
  },
  computed: {
    yearList () {
        return helpers.getYearList()
    },
    eventTypeList: function () {
        return this.$store.state.AwarenessEventService.commonObj.eventTypeList.filter(item => item.status === 1)
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('retailerManagement.year'), class: 'text-center' },
          { label: this.$t('retailerManagement.registration_id'), class: 'text-center' },
          { label: this.$t('retailerManagement.registration_date'), class: 'text-center' },
          { label: this.$t('event_manage.org_name'), class: 'text-left' },
          { label: this.$t('awareness_config.event_type_name'), class: 'text-left' },
          { label: this.$t('awareness_config.event_info'), class: 'text-left' },
          { label: this.$t('awareness_config.stall_type'), class: 'text-left' },
          { label: this.$t('event_manage.payment_type'), class: 'text-left' },
          { label: this.$t('globalTrans.action'), class: 'text-left' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'year' },
          { key: 'registration_id' },
          { key: 'registration_date' },
          { key: 'org_name_bn' },
          { key: 'event_type_name_bn' },
          { key: 'event_name_bn' },
          { key: 'stall_type_name_bn' },
          { key: 'payment_type_bn' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'year' },
          { key: 'registration_id' },
          { key: 'registration_date' },
          { key: 'org_name' },
          { key: 'event_type_name' },
          { key: 'event_name' },
          { key: 'stall_type_name' },
          { key: 'payment_type' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'search.event_type_id': function (newVal, oldVal) {
      if (newVal) {
        this.search.event_info_id = 0
        this.eventList = this.getEventList(newVal)
      } else {
        this.eventList = []
      }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    flatpickr('.date-picker', {})
  },
  methods: {
    view (item) {
      this.viewitemId = item.id
      this.item = item
    },
    searchData () {
      this.loadData()
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(awarenessEventServiceBaseUrl, direactAssignList, params).then(response => {
          if (response.success) {
            this.data = this.getCustomDataList(response.data.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getCustomDataList (data) {
      let eventList = {}
      let eventTypeList = {}
      let stallTypeList = {}
      const listData = data.map(item => {
        const disabledTypeList = this.$store.state.AwarenessEventService.commonObj.disabilityTypeList.find(type => type.value === item.disable_type_id)
          const disabledTypeData = {}
          if (typeof disabledTypeList !== 'undefined') {
              disabledTypeData.disabled_name_en = disabledTypeList.text_en
              disabledTypeData.disabled_name_bn = disabledTypeList.text_bn
          } else {
              disabledTypeData.disabled_name_en = ''
              disabledTypeData.disabled_name_bn = ''
          }
          const divisionList = this.$store.state.commonObj.divisionList.find(division => division.value === item.division_id)
          const divisonData = {}
           if (typeof divisionList !== 'undefined') {
              divisonData.division_name = divisionList.text_en
              divisonData.division_name_bn = divisionList.text_bn
          } else {
              divisonData.division_name = ''
              divisonData.division_name_bn = ''
          }
          const districtList = this.$store.state.commonObj.districtList.find(district => district.value === item.district_id)
          const districtData = {}
          if (typeof districtList !== 'undefined') {
            districtData.district_name = districtList.text_en
            districtData.district_name_bn = districtList.text_bn
          } else {
            districtData.district_name = ''
            districtData.district_name_bn = ''
          }
          eventList = this.$store.state.AwarenessEventService.commonObj.eventList.find(event => event.value === item.event_info_id)
          const list = {
              event_name: eventList !== undefined ? eventList.text_en : '',
              event_name_bn: eventList !== undefined ? eventList.text_bn : ''
          }
          eventTypeList = this.$store.state.AwarenessEventService.commonObj.eventTypeList.find(data => data.value === item.event_type_id)
          const eTypeList = {
              event_type_name: eventTypeList !== undefined ? eventTypeList.text_en : '',
              event_type_name_bn: eventTypeList !== undefined ? eventTypeList.text_bn : ''
          }
          stallTypeList = this.$store.state.AwarenessEventService.commonObj.stallTypeList.find(data => data.value === item.stall_type_id)
          const sTypeList = {
              stall_type_name: stallTypeList !== undefined ? stallTypeList.text_en : '',
              stall_type_name_bn: stallTypeList !== undefined ? stallTypeList.text_bn : ''
          }
         const paymentMethodList = this.paymentTypeList.find(data => data.value === item.payment_type_id)
          const paymentObj = {
              payment_type: paymentMethodList !== undefined ? paymentMethodList.text_en : '',
              payment_type_bn: paymentMethodList !== undefined ? paymentMethodList.text_bn : ''
          }
          return Object.assign({}, item, disabledTypeData, divisonData, districtData, list, eTypeList, sTypeList, paymentObj)
      })
      return listData
    },
    getEventList (eventTypeId = null) {
        const evenList = this.$store.state.AwarenessEventService.commonObj.eventList.filter(item => item.status === 1)

        if (eventTypeId) {
            return evenList.filter(data => data.event_type_id === eventTypeId)
        }

        return evenList
    }
  }
}
</script>
